<div class="flex  items-center  size-full ">
  <div class="relative size-full" *ngIf="!showRiepilogo">
    <div class=" relative z-50 w-full h-full">
      <div class="flex flex-col justify-start " *ngIf="!showRiepilogo">
        <div>
          <h1
            class="text-[var(--secondary)] text-[2.778vh] font-avantgarde font-bold">
            Domanda {{questionario[currentQuestionIndex].id}}</h1>
        </div>
        <div class="mt-[2vh]">
          <p
            class="text-[var(--secondary)] font-avantgarde font-normal text-[2.4vh]">
            {{questionario[currentQuestionIndex].question}}</p>
        </div>
        <div class="size-full mt-[2vh]">
          <div *ngIf="questionario[currentQuestionIndex].questionType !== 'open'">
          <div class="size-full flex items-center z-20 mt-[2vh]"
            *ngFor="let answer of questionario[currentQuestionIndex].questionTypeValues">
       
            <div class="" >
        <!-- checobox -->
      
        <div class="rounded-[1vh] overflow-hidden h-[4vh] w-[4vh] bg-white border-[0.3vh] flex items-center justify-center"> 
          <div class="h-[4vh] w-[4vh] rounded-[1vh] flex justify-center items-center check" 
               [ngClass]="{'bg-[var(--secondary)]': selectedAnswer === answer}" 
               (click)="onCheckboxChange(answer)">
            <img class="h-[3vh] w-[3vh]" *ngIf="selectedAnswer === answer" src="../../../assets/checkIcon.svg">
          </div>
        </div>
        <!-- fine check -->
            </div>
            <div class="size-full ml-[1vw]" >
              <p
                class="font-heebo font-normal text-[2.5vh] text-[var(--secondary)]">
                {{answer}}
              </p>
            </div>
            </div>
          
          </div>
          <div class="size-full" *ngIf="questionario[currentQuestionIndex].questionType === 'open'">
            <textarea placeholder="inserisci testo" [(ngModel)]="text" class="text-area-sec"></textarea>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- riepilogo -->
  <div *ngIf="showRiepilogo&&!showRingraziamenti" class="flex flex-col size-full justify-center items-center">
    <div class="mb-[10px] lg:mb-10 lg:ml-10 flex items-center justify-start size-full overflow-auto">
      <p
        class="font-avantgarde font-bold text-lg lg:text-[34px] lg:leading-10 leading-[21.45px] text-[var(--quaternary)]">
        Riepilogo risposte</p>
    </div>
    <div
      class="p-[30px] lg:p-[60px]  flex flex-col justify-start size-full bg-[var(--tertiary)] rounded-[30px] ombra-pad">
      <div *ngFor="let item of questionario ; let index =index">
        <div class="size-full flex justify-start items-center mt-[10px] lg:mt-10">
          <h1
            class="text-[var(--secondary)] text-[16px] lg:text-[30px] lg:leading-[35.76px] font-avantgarde font-bold leading-[21.45px]">
            Domanda {{index+1}}</h1>
        </div>
        <div class="mt-[10px]">
          <p
            class="text-[var(--secondary)] text-[14px] lg:text-[26px] lg:leading-[31.17px] font-avantgarde font-normal leading-[19.18px]">
            {{item.question}}</p>
        </div>
        <div class="my-[10px]">
         
            <div class="mt-3">
              <p class="font-normal  font-avantgarde leading-4 text-[14px] lg:text-[26px] lg:leading-[31.17px] ">
                {{item.answerValue}}</p>
           
          </div>
        </div>
        <hr class="w-full bord">
      </div>
    </div>

    <div class="w-full h-14 lg:w-[16.666%] lg:h-16 mt-[10vh]">
      <app-button [text]="'Concludi questionario'" (click)="sendAnswers()" [backgroundColor]="'var(--quaternary)'"
        [color]="'var(--tertiary)'" [borderRadius]="'26'"></app-button>
    </div>

  </div>
</div>
<div *ngIf="showRingraziamenti"
  class="p-[30px] mt-10 lg:p-[60px] mb-20  flex flex-col justify-start size-full bg-[var(--tertiary)] rounded-[30px] ombra-pad">

  <div class="mx-auto w-20 h-20 bg-[var(--primary)] rounded-full mt-[70 mb-5 flex place-content-center">
    <img height="50" width="50" src="../../../assets/checkIcon.svg">
  </div>
  <div class="text-[16px] font-bold mb-10 text-center">Hai concluso correttamente
    il questionario</div>
  <div class="font-normal text-[14px] text-center">
    Grazie per aver compilato il questionario
    di DaPico HR, i dati da te forniti serviranno
    per progettare al meglio i nostri prodotti.</div>
</div>
<div class="mt-[10vh] " *ngIf="!showRiepilogo">
  <div class="flex items-center place-content-center lg:justify-end gap-[2.777vh]">
    <div class=" z-[99999999]">
      <app-button [text]="'Precedente'" (click)="previousQuestion()" [backgroundColor]="'var(--quaternary)'"
      [color]="'var(--tertiary)'" [borderRadius]="'10'"></app-button>
    </div>
    <div class="" [class.opacity-50]="selectedAnswer.length===0 && text ===''"
      [style.pointer-events]="selectedAnswer.length===0 && text ==='' ? 'none' : 'auto'">
      <app-button [text]="'Prossima'" (click)="nextQuestion()" [backgroundColor]="'var(--quaternary)'"
        [color]="'var(--tertiary)'" [borderRadius]="'10'"></app-button>
    </div>
  </div>
</div>

